import { faClipboard, faFileDownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { Dispatch, SetStateAction } from "react";
import UnForm from "../../../../Components/Form";
import OrSpinner from "../../../../Components/Utils/OrSpinner";
import VisualizarAssinaturas from "../../../../Components/VisualizarAssinaturasEntregaChaves";
import saveAs from "file-saver";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import { useHistoricoContext } from "../../../../Context/Historico";

import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";

import { FormatterRG } from "../../../../Validations/InputMasks";
import { Spinner } from "../../../../Components/Loding/SpinnerPadrao";
import BlocoAssinaturaAssistenciaTecnica from "../../../../Components/CardsPages/BlocoAssinaturaAssistenciaTecnica";
import { useModuloInfo } from "../../../../Context/ModuloInfo";
import { ACESSOS } from "../../../../Routes/Acessos";
import { IAcompanhamentosVistoria } from "../../../../Interfaces/VistoriaEntregaChaves/AcompanhamentosVistoria/AcompanhamentosVistoriaInterfaces";
import {
    BaixarFormularioPDFController,
    ListarPesquisaRespondidaController,
    CadastrarPesquisaRespondidaController,
} from "../../../../Controllers/Geral/Formularios/FormulariosControllers";
import { ListarPerguntasERespostarFormController } from "../../../../Controllers/Geral/Formularios/PerguntasERespostas/PerguntasERespostasControllers";
import { IResponderPesquisaSatisfacao } from "../../../../Interfaces/Geral/Formularios/FormulariosInterface";

interface IVisualizarFormularioProps {
    setShow: Dispatch<SetStateAction<boolean>>;
    idFormulario: number;
    respondendoFormulario?: boolean;
    visualizandoFormRespondido?: boolean;
    idCaso?: number;
    cdEtapa?: string;
    exportarPdf?: boolean;
    nrAgrupamento?: string;
    row?: IAcompanhamentosVistoria["relatorioAcompanhamentoVistoria"][0];
}

export default function VisualizarFormulario(
    props: IVisualizarFormularioProps
) {
    const { ID_CASO, updateAtendimento } = useAtendimentoPage();
    const { ReloadHistorico } = useHistoricoContext();
    const { id } = useModuloInfo();

    const {
        execute: BaixarFormularioPDF,
        loading: BaixarFormularioPDFLoading,
    } = useAsyncCallback(BaixarFormularioPDFController);

    const {
        value: ListarFormulario,
        loading: ListarFormularioLoading,
        // execute: updateList
    } = useAsyncEffect(async () =>
        ListarPerguntasERespostarFormController(props.idFormulario)
    );

    const {
        value: ListarRespostas,
        loading: ListarPerguntasERespostasLoading,
    } = useAsyncEffect(async () => {
        if (ID_CASO || props.idCaso) {
            return ListarPesquisaRespondidaController(
                ID_CASO ?? props.idCaso,
                props.nrAgrupamento
            );
        }
    }, [props.visualizandoFormRespondido]);

    const {
        execute: CadastrarPesquisaRespondida,
        loading: CadastrarPesquisaRespondidaLoading,
    } = useAsyncCallback(CadastrarPesquisaRespondidaController);

    const handleCadastrarPesquisaRespondida = (
        formData: IResponderPesquisaSatisfacao
    ) => {
        const listaRespondidos = formData.Respondidas.map((respondida) => ({
            ...respondida,
            ID_FORMULARIO: props.idFormulario,
        }));

        CadastrarPesquisaRespondida(ID_CASO, {
            ...formData,
            Respondidas: listaRespondidos,
            Recebimento: {
                ...formData.Recebimento,
                DT_ASSINATURA: new Date(
                    new Date().getTime() - 180 * 60000
                ).toISOString(),
                //data: diminui da data atual 180 minutos (GMT -3) padrão brasileiro. Depois a transforma em padrão ISO string
                //necessário fazer isso pois o IDO usa o fuso GMT zero
            },
        }).then((res) => {
            props.setShow(false);
            updateAtendimento();
            ReloadHistorico();
        });
    };

    const findDsComentario = (value: number) => {
        const findValue = ListarRespostas?.find(
            (resposta) => resposta.ID_PERGUNTA === value
        );
        return findValue?.DS_COMENTARIO || "";
    };

    return (
        <>
            <OrSpinner
                spinner="capys"
                loading={
                    ListarFormularioLoading ||
                    CadastrarPesquisaRespondidaLoading ||
                    ListarPerguntasERespostasLoading
                }
            >
                {props.exportarPdf && (
                    <>
                        <div className="flex-wrap modal-header pt-0 pb-3">
                            <div
                                className="w-100 d-flex justify-content-between align-itens-center modal-title h4"
                                id="contained-modal-title-vcenter"
                            >
                                <div className="d-flex align-itens-end w-100 justify-content-between">
                                    <div className="mt-2">
                                        <FontAwesomeIcon
                                            icon={faClipboard}
                                            className="fa-w-12 fa-lg mr-2"
                                        />
                                        Ver Formulário
                                    </div>
                                    <div className="d-flex align-items-center justify-content-center">
                                        <button
                                            className="btn btn-success font-weight-bold justify-content-center"
                                            disabled={
                                                BaixarFormularioPDFLoading
                                            }
                                            onClick={() => {
                                                BaixarFormularioPDF(
                                                    props.idFormulario,
                                                    props.idCaso ?? 0,
                                                    props.nrAgrupamento
                                                ).then((res) => {
                                                    if (res) {
                                                        saveAs(
                                                            res,
                                                            `Formulário-${props.idCaso}`
                                                        );
                                                    }
                                                });
                                            }}
                                        >
                                            {BaixarFormularioPDFLoading ? (
                                                <span className="d-flex justify-content-center align-items-center g-2">
                                                    <Spinner size="sm" />
                                                    Exportar como PDF
                                                </span>
                                            ) : (
                                                <>
                                                    <FontAwesomeIcon
                                                        icon={faFileDownload}
                                                        className="fa-w-6 fa-md mr-2"
                                                    />
                                                    Exportar como PDF
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
                <div className="d-flex align-items-center justify-content-center mb-20 mt-5">
                    <h3>{ListarFormulario?.DS_FORMULARIO}</h3>
                </div>

                <div className="d-flex flex-column">
                    <span style={{ fontSize: 18 }}>
                        <span className="font-weight-bold">ID Caso:</span>{" "}
                        {props.row?.ID_CASO ? props.row?.ID_CASO : "-"}
                    </span>{" "}
                    <span style={{ fontSize: 18 }}>
                        <span className="font-weight-bold">
                            Data de Assinatura da Vistoria:
                        </span>{" "}
                        {props.row?.DT_ASSINATURA
                            ? props.row?.DT_ASSINATURA
                            : "-"}
                    </span>
                    <span style={{ fontSize: 18 }}>
                        <span className="font-weight-bold">
                            Empreendimento:
                        </span>{" "}
                        {props.row?.DS_PRODUTO ? props.row?.DS_PRODUTO : "-"}
                    </span>
                    <span style={{ fontSize: 18 }}>
                        <span className="font-weight-bold">
                            Técnico Responsável:
                        </span>{" "}
                        {ListarRespostas?.[0]?.DS_NOME_TECNICO
                            ? ListarRespostas?.[0].DS_NOME_TECNICO
                            : "-"}
                    </span>
                </div>
                <UnForm handleSubmit={handleCadastrarPesquisaRespondida}>
                    {ListarFormulario?.ListaPesquisaSatisfacaoPerguntaRespostas?.map(
                        (perguntaPai, index) => (
                            <div
                                key={perguntaPai.ID_PERGUNTA}
                                className={`h-100 mb-5 wrap ${
                                    perguntaPai.ID_PERGUNTA_PAI &&
                                    "ml-25 mb-0 mt-0 mr-25"
                                } ${!perguntaPai.FL_ATIVO && "d-none"}`}
                            >
                                <>
                                    <hr className="mb-5 mt-5" />
                                    <h4>{perguntaPai.DS_PERGUNTA}</h4>
                                </>

                                <ul className="d-flex list-unstyled justify-content-around flex-wrap">
                                    {perguntaPai.ID_TIPO_PERGUNTA !== 3 ? (
                                        <>
                                            {perguntaPai.PesquisaSatisfacaoRespostas?.map(
                                                (resposta) => (
                                                    <React.Fragment
                                                        key={
                                                            resposta.ID_RESPOSTA
                                                        }
                                                    >
                                                        <li
                                                            className="m-5"
                                                            style={{
                                                                height: 80,
                                                                display: "flex",
                                                                alignItems:
                                                                    "center",
                                                                justifyContent:
                                                                    "center",
                                                                flexDirection:
                                                                    "column",
                                                                textAlign:
                                                                    "center",
                                                            }}
                                                        >
                                                            <UnForm.Input
                                                                readOnly
                                                                name={`Respondidas.${index}.ID_PERGUNTA`}
                                                                value={
                                                                    perguntaPai.ID_PERGUNTA
                                                                }
                                                                style={{
                                                                    display:
                                                                        "none",
                                                                }}
                                                                wrapperClassName="d-none"
                                                            />

                                                            {perguntaPai.ID_TIPO_PERGUNTA ===
                                                            1 ? (
                                                                <UnForm.Input
                                                                    name={`Respondidas.${index}.idRespostas.0`}
                                                                    label={
                                                                        resposta.DS_RESPOSTA
                                                                    }
                                                                    type={
                                                                        "radio"
                                                                    }
                                                                    wrapperClassName="d-flex flex-column justify-content-center align-items-center"
                                                                    style={{
                                                                        height: 35,
                                                                        width: 35,
                                                                    }}
                                                                    value={
                                                                        resposta.ID_RESPOSTA
                                                                    }
                                                                    disabled={
                                                                        props.visualizandoFormRespondido ===
                                                                        true
                                                                    }
                                                                    defaultChecked={ListarRespostas?.some(
                                                                        (res) =>
                                                                            res.ID_RESPOSTA ===
                                                                            resposta.ID_RESPOSTA
                                                                    )}
                                                                />
                                                            ) : null}

                                                            {perguntaPai.ID_TIPO_PERGUNTA ===
                                                            2 ? (
                                                                <UnForm.Input
                                                                    type="checkbox"
                                                                    color="primary"
                                                                    name={`Respondidas.${index}.idRespostas`}
                                                                    label={
                                                                        resposta.DS_RESPOSTA
                                                                    }
                                                                    value={
                                                                        resposta.ID_RESPOSTA
                                                                    }
                                                                    wrapperClassName="mt-5 d-flex flex-column justify-content-center align-items-center"
                                                                    style={{
                                                                        height: 35,
                                                                        width: 35,
                                                                    }}
                                                                    disabled={
                                                                        props.visualizandoFormRespondido ===
                                                                        true
                                                                    }
                                                                    defaultChecked={ListarRespostas?.some(
                                                                        (res) =>
                                                                            res.ID_RESPOSTA ===
                                                                            resposta.ID_RESPOSTA
                                                                    )}
                                                                />
                                                            ) : null}
                                                        </li>
                                                    </React.Fragment>
                                                )
                                            )}
                                        </>
                                    ) : null}
                                </ul>

                                {ListarRespostas?.filter(
                                    (x) =>
                                        x.ID_PERGUNTA ===
                                        perguntaPai.ID_PERGUNTA
                                ) &&
                                    ListarRespostas?.find(
                                        (x) =>
                                            x.ID_PERGUNTA ===
                                            perguntaPai.ID_PERGUNTA
                                    )?.RESPOSTA_JUSTIFICATIVA && (
                                        <UnForm.Textarea
                                            name="Justificativa"
                                            defaultValue={ListarRespostas?.find(
                                                (x) =>
                                                    x.ID_PERGUNTA ===
                                                    perguntaPai.ID_PERGUNTA
                                            )?.RESPOSTA_JUSTIFICATIVA?.map(
                                                (ma) => ma.DS_JUSTIFICATIVA
                                            )}
                                            disabled
                                        />
                                    )}

                                {!perguntaPai.ID_PERGUNTA_PAI && (
                                    <>
                                        <UnForm.Input
                                            readOnly
                                            name={`Respondidas.${index}.ID_PERGUNTA`}
                                            value={perguntaPai.ID_PERGUNTA}
                                            style={{
                                                display: "none",
                                            }}
                                            wrapperClassName="d-none"
                                        />
                                        <UnForm.Textarea
                                            label={
                                                perguntaPai.ID_TIPO_PERGUNTA ===
                                                3
                                                    ? "Resposta"
                                                    : "Comentário"
                                            }
                                            name={`Respondidas.${index}.DS_COMENTARIO`}
                                            disabled={
                                                props.visualizandoFormRespondido ===
                                                true
                                            }
                                            defaultValue={findDsComentario(
                                                perguntaPai.ID_PERGUNTA
                                            )}
                                        />
                                    </>
                                )}

                                {perguntaPai.PerguntasFilhas?.map(
                                    (pergunta) => (
                                        <div className="h-100 mb-5 wrap ml-25 mb-0 mt-0 mr-25 false">
                                            <div className="mt-8">
                                                <h4>
                                                    {perguntaPai.DS_PERGUNTA}
                                                </h4>
                                            </div>
                                            <ul className="d-flex list-unstyled justify-content-around flex-wrap">
                                                {pergunta.ID_TIPO_PERGUNTA !==
                                                3 ? (
                                                    <>
                                                        {pergunta.PesquisaSatisfacaoRespostas.map(
                                                            (resposta) => (
                                                                <React.Fragment
                                                                    key={
                                                                        resposta.ID_RESPOSTA
                                                                    }
                                                                >
                                                                    <li
                                                                        className="m-5"
                                                                        style={{
                                                                            height: 80,
                                                                            display:
                                                                                "flex",
                                                                            alignItems:
                                                                                "center",
                                                                            justifyContent:
                                                                                "center",
                                                                            flexDirection:
                                                                                "column",
                                                                            textAlign:
                                                                                "center",
                                                                        }}
                                                                    >
                                                                        <UnForm.Input
                                                                            readOnly
                                                                            name={`Respondidas.${index}.ID_PERGUNTA`}
                                                                            value={
                                                                                pergunta.ID_PERGUNTA
                                                                            }
                                                                            style={{
                                                                                display:
                                                                                    "none",
                                                                            }}
                                                                            wrapperClassName="d-none"
                                                                        />

                                                                        {pergunta.ID_TIPO_PERGUNTA ===
                                                                        1 ? (
                                                                            <UnForm.Input
                                                                                name={`Respondidas.${index}.idRespostas.0`}
                                                                                label={
                                                                                    resposta.DS_RESPOSTA
                                                                                }
                                                                                type={
                                                                                    "radio"
                                                                                }
                                                                                wrapperClassName="d-flex flex-column justify-content-center align-items-center"
                                                                                style={{
                                                                                    height: 35,
                                                                                    width: 35,
                                                                                }}
                                                                                value={
                                                                                    resposta.ID_RESPOSTA
                                                                                }
                                                                                disabled={
                                                                                    props.visualizandoFormRespondido ===
                                                                                    true
                                                                                }
                                                                                defaultChecked={ListarRespostas?.some(
                                                                                    (
                                                                                        res
                                                                                    ) =>
                                                                                        res.ID_RESPOSTA ===
                                                                                        resposta.ID_RESPOSTA
                                                                                )}
                                                                            />
                                                                        ) : null}

                                                                        {pergunta.ID_TIPO_PERGUNTA ===
                                                                        2 ? (
                                                                            <UnForm.Input
                                                                                type="checkbox"
                                                                                color="primary"
                                                                                name={`Respondidas.${index}.idRespostas`}
                                                                                label={
                                                                                    resposta.DS_RESPOSTA
                                                                                }
                                                                                value={
                                                                                    resposta.ID_RESPOSTA
                                                                                }
                                                                                wrapperClassName="mt-5 d-flex flex-column justify-content-center align-items-center"
                                                                                style={{
                                                                                    height: 35,
                                                                                    width: 35,
                                                                                }}
                                                                                disabled={
                                                                                    props.visualizandoFormRespondido ===
                                                                                    true
                                                                                }
                                                                                defaultChecked={ListarRespostas?.some(
                                                                                    (
                                                                                        res
                                                                                    ) =>
                                                                                        res.ID_RESPOSTA ===
                                                                                        resposta.ID_RESPOSTA
                                                                                )}
                                                                            />
                                                                        ) : null}
                                                                    </li>
                                                                </React.Fragment>
                                                            )
                                                        )}
                                                    </>
                                                ) : null}
                                            </ul>

                                            {ListarRespostas?.find(
                                                (idResposta) =>
                                                    idResposta.FL_NAO_CONFORME
                                            )?.RESPOSTA_JUSTIFICATIVA[index]
                                                .ID_PERGUNTA ===
                                                pergunta.ID_PERGUNTA && (
                                                <UnForm.Textarea
                                                    name="Justificativa"
                                                    defaultValue={ListarRespostas?.find(
                                                        (idResposta) =>
                                                            idResposta.FL_NAO_CONFORME
                                                    )?.RESPOSTA_JUSTIFICATIVA?.map(
                                                        (ma) =>
                                                            ma.DS_JUSTIFICATIVA
                                                    )}
                                                    disabled
                                                />
                                            )}
                                        </div>
                                    )
                                )}

                                <hr />
                            </div>
                        )
                    )}

                    <>
                        <div className="mb-6">
                            <h3>Recebimento:</h3>
                            <span className="mb-5">
                                Declaro que a vistoria e os serviços acima
                                descritos foram executados.
                            </span>
                            <div className="row m-0 mt-5">
                                <UnForm.Input
                                    label={"Nome"}
                                    name={`Recebimento.DS_NOME`}
                                    wrapperClassName="col-6 col-md-6 m-0"
                                    defaultValue={ListarRespostas?.[0]?.DS_NOME}
                                    disabled={props.visualizandoFormRespondido}
                                    registerOptions={{
                                        required: "Insira o Nome",
                                    }}
                                />
                                <UnForm.Input
                                    label={"RG/CPF"}
                                    onChange={(e) =>
                                        FormatterRG(e.target.value)
                                    }
                                    disabled={props.visualizandoFormRespondido}
                                    defaultValue={ListarRespostas?.[0]?.DS_RG}
                                    registerOptions={{
                                        required: "Insira o RG",
                                    }}
                                    name={`Recebimento.DS_RG`}
                                    wrapperClassName="col-6 col-md-6 m-0"
                                />
                            </div>

                            {id === ACESSOS.ASSISTENCIA.ID_MODULO && (
                                <BlocoAssinaturaAssistenciaTecnica
                                    idCaso={ID_CASO ?? props.idCaso}
                                />
                            )}
                        </div>

                        <VisualizarAssinaturas
                            idCaso={props.idCaso ?? 0}
                            cdEtapa={props.cdEtapa}
                        />
                    </>

                    <div className="d-flex justify-content-end">
                        {props.respondendoFormulario && (
                            <button
                                type="submit"
                                className="btn btn-success font-weight-bold mr-2 w-100px"
                            >
                                Enviar
                            </button>
                        )}
                    </div>
                </UnForm>
            </OrSpinner>
        </>
    );
}
